import type { DeckCardThumbnailSourceDebug } from "@/cards/common/types/app-deck/deckCardThumbnail.types";

import { kakaoFallbackImageUrl } from "./resolveKakaoImageUrl";

type LogDeckCardKakaoShareImageInput = {
  mainCardId?: number | string;
  coverImageUrlInput?: string;
  imageUrlInput?: string;
  kakaoImageUrlResolved: string;
  templateImageUrl: string;
  thumbnailSources?: DeckCardThumbnailSourceDebug;
};

/** Logs tile vs cover vs final Kakao `image_url` when sharing a deck card. */
export const logDeckCardKakaoShareImage = ({
  mainCardId,
  coverImageUrlInput,
  imageUrlInput,
  kakaoImageUrlResolved,
  templateImageUrl,
  thumbnailSources,
}: LogDeckCardKakaoShareImageInput): void => {
  console.info("[Kakao share] image_url for KakaoTalk", {
    mainCardId: mainCardId ?? thumbnailSources?.mainCardId,
    coverImageUrlUsedAsInput: coverImageUrlInput?.trim() || imageUrlInput?.trim() || "",
    kakaoImageUrlResolved,
    templateArg_image_url: templateImageUrl,
  });

  const fallback = kakaoFallbackImageUrl();
  if (kakaoImageUrlResolved === fallback && coverImageUrlInput?.trim()) {
    console.warn(
      "[Kakao share] cover/tile URL could not be resolved for Kakao; using site fallback. " +
        "Ensure the image is public HTTPS (not blob/data/localhost).",
      { coverImageUrlInput, fallback },
    );
  }

  if (thumbnailSources) {
    console.info("[Kakao share] thumbnail sources (DeckCardThumbnailTile vs Kakao)", {
      mainCardId: thumbnailSources.mainCardId,
      deckCardThumbnailTile_imageUrl: thumbnailSources.deckCardThumbnailTileImageUrl,
      kakao_coverImageUrl_raw: thumbnailSources.kakaoCoverImageUrlRaw,
      record_cover_image_url: thumbnailSources.recordCoverImageUrl,
      published_coverImageUrl: thumbnailSources.publishedCoverImageUrl,
      content_thumbnail: thumbnailSources.contentThumbnail,
      display_coverImageUrl: thumbnailSources.displayCoverImageUrl,
      display_thumbnailUrl: thumbnailSources.displayThumbnailUrl,
      deckBundleNote: thumbnailSources.deckBundleThumbnailNote,
    });
  }
};
